import { defineComponent as _defineComponent } from 'vue'
import StreamContainer from './StreamContainer';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    showRoomTool: { type: Boolean }
  },
  setup(__props: any) {



return { __sfc: true,StreamContainer }
}

})